module.exports = __webpack_public_path__ + "static/favoriteThings-1c81de81a6981dfa03fca59807214e8f.jpeg";